<template>
    <div class="my-cash-advances-table">
        <div class="content">
            <div class="wrap">
                <div class="wrap__tree">
                    <div class="nav-tree">
                        <div class="nav-tree">
                            <el-radio @change="stateChange" v-model="activeState" size="mini" label="businessUnitTasksCashAdvance" border>{{$t('users_tab_hris_advances_bu')}}</el-radio>
                            <el-radio @change="stateChange" v-model="activeState" size="mini" label="engagementTasksCashAdvance" border>{{$t('users_tab_hris_advances_e')}}</el-radio>
                            <el-radio @change="stateChange" v-model="activeState" size="mini" label="projectTasksCashAdvance" border>{{$t('users_tab_hris_advances_p')}}</el-radio>
                            <el-select class="inputs" :no-data-text="$t('general_noData')" v-model="projectId" :placeholder="placeholder" size="mini">
                                <el-option
                                        v-for="item in projects"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                        @click.native="setValueProjectAfterSubmit(item.id, activeState)">
                                </el-option>
                            </el-select>
                        </div>
                        <el-button @click="openModal(activeState)" class="nav-tree__item_btn" size="mini" type="primary" plain icon="el-icon-plus">{{$t('users_tab_hris_advances_requestCashAdvance')}}</el-button>
                    </div>
                    <el-tabs v-model="advancesTab" type="card" @tab-click="handleClickTabs">
                        <el-tab-pane name="requestTasksCashAdvance" :label="$t('users_tab_hris_advances_requestCashAdvances')"></el-tab-pane>
                        <el-tab-pane name="tasksCashAdvance" :label="$t('users_tab_hris_advances_cashAdvances')"></el-tab-pane>
                    </el-tabs>
                    <el-table
                            :data="myCashAdvanceList"
                            style="width: 100%;"
                            :empty-text="$t('general_noData')"
                            :cell-class-name="cellClassName"
                            :row-class-name="tableRowClassName"
                            :header-cell-class-name="headerCellClassName"
                            @cell-click="cellClick">
                        <el-table-column
                                type="index"
                                width="50">
                        </el-table-column>
                        <el-table-column
                                prop="code"
                                :label="$t('users_tab_hris_advances_no')"
                                width="100">
                        </el-table-column>
                        <el-table-column
                                prop="expenseDate"
                                :label="$t('users_tab_hris_advances_date')"
                                width="110">
                        </el-table-column>
                        <el-table-column
                                prop="projectTaskExpenseInventoryItemId.name"
                                :label="$t('users_tab_hris_advances_expenseItem')"
                                width="100">
                        </el-table-column>
                        <el-table-column
                                prop="status"
                                :label="$t('users_tab_hris_advances_status')"
                                width="90">
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.status === 'Pending'"
                                           size="mini"
                                           type="info"
                                           plain
                                           v-html="scope.row.status">
                                </el-button>
                                <el-button v-if="scope.row.status === 'Submited'"
                                           size="mini"
                                           type="primary"
                                           plain
                                           v-html="advancesTab === 'tasksCashAdvance' ? 'Submited' : 'Requested' ">
                                    <!--{{scope.row.status}}-->
                                </el-button>
                                <el-button v-if="scope.row.status === 'Approved'"
                                           size="mini"
                                           type="success"
                                           plain
                                           v-html="scope.row.status">
                                </el-button>
                                <el-button v-if="scope.row.status === 'Rejected'"
                                           size="mini"
                                           type="danger"
                                           plain
                                           v-html="scope.row.status">
                                </el-button>
                                <el-button v-if="scope.row.status === 'Deposit'"
                                           size="mini"
                                           type="warning"
                                           plain
                                           v-html="scope.row.status">
                                </el-button>
                                <el-button v-if="scope.row.status === 'Received'"
                                           size="mini"
                                           type="primary"
                                           plain
                                           v-html="scope.row.status">
                                </el-button>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="companyClient.name"
                                :label="$t('users_tab_hris_advances_client')"
                                width="120">
                        </el-table-column>
                        <el-table-column
                                prop="project.name"
                                :label="$t('users_tab_hris_advances_project')"
                                width="180">
                        </el-table-column>
                        <el-table-column
                                prop="companyUser.user.fullName"
                                :label="$t('users_tab_hris_advances_from')"
                                width="150">
                        </el-table-column>
                        <el-table-column
                                prop="amount"
                                :label="$t('users_tab_hris_advances_amount')"
                                width="100">
                            <template slot-scope="scope">
                                {{formatPrice(scope.row.amount)}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                :label="$t('users_tab_hris_advances_file')"
                                width="50">
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.fileId !== null"
                                           size="mini"
                                           type="primary"
                                           circle
                                           icon="el-icon-link"
                                           @click="handleShowImg(scope.$index, scope.row, activeState)"></el-button>
                            </template>
                        </el-table-column>
                        <el-table-column
                                :label="$t('users_tab_hris_advances_operations')"
                                width="250">
                            <template slot-scope="scope">
                                <el-button
                                        v-if="scope.row.status === 'Pending'"
                                        size="mini"
                                        type="primary"
                                        plain
                                        :disabled="scope.row.isLocked === 1"
                                        @click="handleSubmit(scope.$index, scope.row, activeState, advancesTab)" v-html="advancesTab === 'tasksCashAdvance' ? 'Submit' : 'Request' "></el-button>
                                <el-button
                                        v-if="scope.row.status === 'Pending' || scope.row.status === 'Rejected'"
                                        size="mini"
                                        type="primary"
                                        plain
                                        icon="el-icon-edit"
                                        :disabled="scope.row.isLocked === 1"
                                        @click="handleEdit(scope.$index, scope.row, activeState, advancesTab)"></el-button>
                                <el-button
                                        size="mini"
                                        type="danger"
                                        plain
                                        icon="el-icon-delete"
                                        :disabled="scope.row.isLocked === 1"
                                        @click="handleDelete(scope.$index, scope.row, activeState, advancesTab)"></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>

        <projectCashAdvanceModal
                @setValueProject='setValueProjectAfterSubmitModal'
                :selectedRow="selectedRow"
                ref="projectCashAdvanceModal"/>

        <!--REQUEST CASH ADVANCE ADD EDIT MODAL START-->
        <requestProjectCashAdvanceModal
                @setValueProject='setValueProjectAfterSubmitModal'
                :selectedRow="selectedRow"
                ref="requestProjectCashAdvanceModal"/>
        <!--REQUEST CASH ADVANCE ADD EDIT MODAL END-->


        <cashAdvanceInfoModal
                ref="cashAdvanceInfoModal"
                @refreshCashAdvancePage="setValueProjectAfterSubmitModal"/>


        <div v-if="viewerType == 1">
            <sweet-modal blocking v-if="viewerType == 1" ref="nestedChild">
                <iframe class="iframe" :src="fileUrl" frameborder="0"></iframe>
            </sweet-modal>
        </div>
        <div v-if="viewerType == 2">
            <div v-show="false" class="images" v-viewer="{movable: true}">
                <img :src="fileUrl" :key="fileUrl" />
            </div>
        </div>
        <div class="mod" v-if="viewerType == 3">
            <div @click="closeMod" class="mod__close">
                <span>x</span>
            </div>
            <Media
                    :kind="'video'"
                    :controls="true"
                    :src="fileUrl"
            >
            </Media>
        </div>
        <div class="mod" v-if="viewerType == 4">
            <div @click="closeMod" class="mod__close">
                <span>x</span>
            </div>
            <Media
                    :kind="'audio'"
                    :controls="true"
                    :src="fileUrl"
            >
            </Media>
        </div>
    </div>
</template>

<script>
  import Media from '@dongido/vue-viaudio'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue';
  import projectCashAdvanceModal from '@/components/Projects/projectCashAdvanceModal.vue'
  import cashAdvanceInfoModal from '@/components/cash-davances/cashAdvanceInfoModal.vue'
  import requestProjectCashAdvanceModal from '@/components/Projects/requestProjectCashAdvanceModal.vue'


  let moment = require('moment')
  import axios from 'axios'
  export default {
    name: 'myCashAdvanceTable',
    components: {
      SweetModal,

      projectCashAdvanceModal,
      cashAdvanceInfoModal,
      requestProjectCashAdvanceModal,
      Media
    },
    mounted() {

    },
    data(){
      return {
        advancesTab: 'tasksCashAdvance',
        activeState:'projectTasksCashAdvance',
        projectId: '',
        projects: [],
        myCashAdvanceList: [],
        placeholder: 'Select Project',
        moment:moment,
        viewerType: 0,
        fileUrl: '',
        type: '',
        selectedRow:{},
        // selectedRowId:'',
      }
    },
    methods: {
      openModal(state){
        const urlParts = this.buildUrl(state, 'requestTasksCashAdvance')
        this.$refs['requestProjectCashAdvanceModal'].openModalFromCashAdvance(urlParts.myState)
      },
      stateChange(state){
        this.getProjects(state)
      },
      openTable(){
        this.getProjects(this.activeState)
      },
      handleClickTabs(tab, event){
        if(this.projectId === 'all'){
          this.setMyValueProjectAll(this.activeState, tab.name)
        }else{
          this.setMyValueProject(this.projectId, this.activeState, tab.name)
        }
      },
      getProjects(state){
        let myState = ''
        switch (state){
          case 'projectTasksCashAdvance':
            this.projects = [{name: this.$i18n.t('users_tab_hris_advances_p_all'), id: 'all'}]
            myState = 'projects'
            break;
          case 'engagementTasksCashAdvance':
            this.projects = [{name: this.$i18n.t('users_tab_hris_advances_e_all'), id: 'all'}]
            myState = 'engagements'
            break;
          case 'businessUnitTasksCashAdvance':
            this.projects = [{name: this.$i18n.t('users_tab_hris_advances_bu_all'), id: 'all'}]
            myState = 'businessUnits'
            break;
        }
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${myState}/list?companyId=${this.$route.query.companyId}`)
          .then(response => {
            this.projects =  this.projects.concat(response.data.list)
            this.projectId = this.projects[0].id
            this.setValueProjectAfterSubmit(this.projectId, state)
          }).catch(error =>{

        })
      },
      cellClick(row, column, event){
        if(column.label !== 'File' && column.label !== 'Operations') {
          const urlParts = this.buildUrl(this.activeState, this.advancesTab)
          this.openCashAdvanceModal(row.companyId, row.projectId, row.projectTaskId, row.id, urlParts.myState)
        }
      },
      openCashAdvanceModal(companyId, projectId, projectTaskId, projectTaskExpenseId, state){
        this.$refs.cashAdvanceInfoModal.openModalInfo(companyId, projectId, projectTaskId, projectTaskExpenseId, state);
      },
      setValueProjectAfterSubmitModal(projectId){
            if(this.projectId === 'all'){
              this.setMyValueProjectAll(this.activeState, this.advancesTab)
            }else{
              this.setMyValueProject(projectId, this.activeState, this.advancesTab)
            }
      },
      setValueProjectAfterSubmit(projectId, state){
            if(projectId === 'all'){
              this.setMyValueProjectAll(state, this.advancesTab)
            }else{
              this.setMyValueProject(projectId, state, this.advancesTab)
            }
      },
      setMyValueProject(projectId, state, activeTab){
        this.projectId = projectId;

        const urlParts = this.buildUrl(state, activeTab);

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${urlParts.myState}/myList?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${projectId}`)
          .then(response => {
            this.myCashAdvanceList = response.data.list
            loader.hide()
          }).catch(error =>{
          loader.hide()
        })
      },
      setMyValueProjectAll(state, activeTab){
        const urlParts = this.buildUrl(state, activeTab)
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${urlParts.myState}/myList?companyId=${this.$route.query.companyId}`)
          .then(response => {
            this.myCashAdvanceList = response.data.list
            loader.hide()
          }).catch(error =>{
          loader.hide()
        })
      },
      checkType(url) {
        let type = url.split('.').pop().toUpperCase()
        if (type == 'STEP' || type == 'STP' || type == 'IGES' || type == 'IGS' || type == 'BREP' || type == 'STL' || type == 'SAT' || type == 'X_T' || type == 'X_B' || type == 'SLDPRT' || type == 'DWG' || type == 'DXF' || type == 'DWF' || type == 'HPGL' || type == 'PLT' || type == 'CGM' || type == 'SVG' || type == 'EMF' || type == 'WMF' || type == 'JPG' || type == 'JPEG' || type == 'PNG' || type == 'BMP' || type == 'OGG' || type == 'MP4' || type == 'WMA' || type == 'MP3' || type == 'WAV' || type == 'OGG' || type == 'M4A' || type == 'PDF') {
          return true
        } else {
          return false
        }
      },
      handleSubmit(index, row, state, activeTab) {

        if(row.projectTaskId === null){
          row.projectTaskId = 0
        }

        const urlParts = this.buildUrl(state, activeTab, row)

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${urlParts.myState}/submit?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${urlParts.projectId}&${urlParts.stateTaskId}=${urlParts.taskId}&${urlParts.stateCashAdvanceId}=${row.id}`)
          .then(response => {
            this.notification("Success", "Submit Expense", "success")
            this.setValueProjectAfterSubmit(this.projectId, state)
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
        console.log(index, row)
      },
      handleEdit(index, row, state, activeTab) {
        const urlParts = this.buildUrl(state, activeTab)
        this.$refs['requestProjectCashAdvanceModal'].openModalFromCashAdvanceEdit(row, urlParts.myState)
      },
      handleShowImg(index, row, state){


        if(row.projectTaskId === null){
          row.projectTaskId = 0
        }

        const urlParts = this.buildUrl(state, this.advancesTab, row)

        //TODO add BU ENG

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${urlParts.myState}/fieldInfo?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${urlParts.projectId}&${urlParts.stateTaskId}=${urlParts.taskId}&${urlParts.stateCashAdvanceId}=${row.id}&field=file`)
          .then(response => {
            this.viewFile(response.data.fieldInfo.url)
          })
          .catch(error => {
            // this.$refs.confirmation.close()
            console.log('An error occurred:', error);
          });
      },
      viewFile(url) {
        let type = url.split('.').pop().toUpperCase()
        if (type == 'STEP' || type == 'STP' || type == 'IGES' || type == 'IGS' || type == 'BREP' || type == 'STL' || type == 'SAT' || type == 'X_T' || type == 'X_B' || type == 'SLDPRT' || type == 'DWG' || type == 'DXF' || type == 'DWF' || type == 'HPGL' || type == 'PLT' || type == 'CGM' || type == 'SVG' || type == 'EMF' || type == 'WMF' || type == 'JPG' || type == 'JPEG' || type == 'PNG' || type == 'BMP' || type == 'OGG' || type == 'MP4' || type == 'WMA' || type == 'MP3' || type == 'WAV' || type == 'OGG' || type == 'M4A' || type == 'PDF') {
          this.fileUrl = url
          this.type = this.fileUrl.split('.').pop().toUpperCase()
          console.log('---', this.fileUrl, this.type);

          if (this.type == 'JPG' || this.type == 'JPEG' || this.type == 'PNG' || this.type == 'BMP') {
            this.viewerType = 2;
            setTimeout(() => {
              console.log('-----', this.$el);
              const viewer = this.$el.querySelector('.images').$viewer
              viewer.show()
            }, 300);
          } else if (this.type == 'OGG' || this.type == 'MP4') {
            this.viewerType = 3;
            setTimeout(() => {
              // this.$refs.video.open();
            }, 300);
          } else if (this.type == 'WMA' || this.type == 'MP3' || this.type == 'WAV' || this.type == 'OGG' || this.type == 'M4A') {
            this.viewerType = 4;
            setTimeout(() => {
              // this.$refs.video.open();
            }, 300);
          } else if (this.type == 'PDF') {
            this.viewerType = 1;
            this.fileUrl = process.env.VUE_APP_TF_PDF_VIEWER_BASE_URL + '/?file=' + this.fileUrl
            setTimeout(() => {
              // this.$refs.nestedChild.open();
              window.open(this.fileUrl);
            }, 300);
          } else if (this.type == 'STEP' || this.type == 'STP' || this.type == 'IGES' || this.type == 'IGS' || this.type == 'BREP' || this.type == 'STL' || this.type == 'SAT' || this.type == 'X_T' || this.type == 'X_B' || this.type == 'SLDPRT' || this.type == 'DWG' || this.type == 'DXF' || this.type == 'DWF' || this.type == 'HPGL' || this.type == 'PLT' || this.type == 'CGM' || this.type == 'SVG' || this.type == 'EMF' || this.type == 'WMF') {
            // this.viewerType = 1;
            this.fileUrl = 'https://sharecad.org/cadframe/load?url=' + this.fileUrl
            setTimeout(() => {
              // this.$refs.nestedChild.open();
              window.open(this.fileUrl);
            }, 300);
          }
        }
      },
      cellClassName({row, column, rowIndex, columnIndex}){
        // console.log("COLUMN", columnIndex)
        // if(columnIndex === 0 || columnIndex === 5){
        //   return 'align-center'
        // }
      },
      tableRowClassName({row, rowIndex}) {
        return 'table-rows'
      },
      headerCellClassName({row, column, rowIndex, columnIndex}){
        // if(columnIndex === 0 || columnIndex === 5){
        //   return 'align-center'
        // }
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      handleDelete(index, row, state, activeTab){

        // this.selectedProjectIdforDel = row.projectId
        // this.selectedTaskIdforDel = row.projectTaskId
        // this.selectedRowId = row.id

        const urlParts = this.buildUrl(state, activeTab)

        this.$confirm('This will permanently delete the Cash Advance. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'info'
        }).then(() => {
          this.$message({
            type: 'success',
            message: 'Delete completed'
          });

          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/${urlParts.myState}/delete?${urlParts.stateCashAdvanceId}=${row.id}`)
            .then(response => {
              this.setValueProjectAfterSubmit(this.projectId, state)
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });
        });
      },
      buildUrl(state, activeTab, row) {
        console.log('state, activeTab, row', state, activeTab, row)
        let myState = ''
        let stateProjectId = ''
        let stateTaskId = ''
        let projectId = ''
        let taskId = ''
        let stateCashAdvanceId = ''
        switch (activeTab) {
          case 'tasksCashAdvance':
            if (state === 'projectTasksCashAdvance') {
              myState = 'projectTasksCashAdvance'
              stateProjectId = 'projectId'
              stateTaskId = 'projectTaskId'
              if(row){
                projectId = row.project.id
                taskId = row.projectTaskId
              }
              stateCashAdvanceId = 'projectTaskCashAdvanceId'
            } else if (state === 'engagementTasksCashAdvance') {
              myState = 'engagementTasksCashAdvance'
              stateProjectId = 'engagementId'
              stateTaskId = 'engagementTaskId'
              if(row){
                projectId = row.engagement.id
                taskId = row.engagementTaskId
              }
              stateCashAdvanceId = 'engagementTaskCashAdvanceId'
            } else if (state === 'businessUnitTasksCashAdvance') {
              myState = 'businessUnitTasksCashAdvance'
              stateProjectId = 'businessUnitId'
              stateTaskId = 'businessUnitTaskId'
              if(row){
                projectId = row.businessUnit.id
                taskId = row.businessUnitTaskId
              }
              stateCashAdvanceId = 'businessUnitTaskCashAdvanceId'
            }
            break;
          case 'requestTasksCashAdvance':
            if (state === 'projectTasksCashAdvance') {
              myState = 'requestProjectTasksCashAdvance'
              stateProjectId = 'projectId'
              stateTaskId = 'projectTaskId'
              if(row){
                projectId = row.project.id
                taskId = row.projectTaskId
              }
              stateCashAdvanceId = 'projectTaskCashAdvanceId'
            } else if (state === 'engagementTasksCashAdvance') {
              myState = 'requestEngagementTasksCashAdvance'
              stateProjectId = 'engagementId'
              stateTaskId = 'engagementTaskId'
              if(row){
                projectId = row.engagement.id
                taskId = row.engagementTaskId
              }
              stateCashAdvanceId = 'engagementTaskCashAdvanceId'
            } else if (state === 'businessUnitTasksCashAdvance') {
              myState = 'requestBusinessUnitTasksCashAdvance'
              stateProjectId = 'businessUnitId'
              stateTaskId = 'businessUnitTaskId'
              if(row){
                projectId = row.businessUnit.id
                taskId = row.businessUnitTaskId
              }
              stateCashAdvanceId = 'businessUnitTaskCashAdvanceId'
            }
            break;
        }
        return {
          myState: myState,
          stateProjectId: stateProjectId,
          stateTaskId: stateTaskId,
          projectId: projectId,
          taskId: taskId,
          stateCashAdvanceId: stateCashAdvanceId
        }
      }
    },
    watch:{
      myCashAdvanceList(val){
        val.forEach(i =>{
          i.expenseDate = moment(i.createDate.toString(), 'X').format('DD MMM YYYY')
          if(i.reimbursable === 1){
            i.reimbursable = 'Reimbursable'
          }else if(i.reimbursable === 0){
            i.reimbursable = false
          }
          if(i.isBillable === 1){
            i.isBillable = 'Billable'
          }else if(i.isBillable === 0){
            i.isBillable = false
          }
          if(i.status === 1){
            i.status = 'Pending'
          }else if(i.status === 2){
            i.status = 'Submited'
          }else if(i.status === 3){
            i.status = 'Approved'
          }else if(i.status === 4){
            i.status = 'Rejected'
          }else if(i.status === 5){
            i.status = 'Deposit'
          }else if(i.status === 6){
            i.status = 'Received'
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
    // [ Nav tree ] start
    .nav-tree {
        padding-bottom: 10px;
        &__item {
            margin: 0 0 5px 0;
            &_btn{
                /*margin-left:10px;*/
            }
        }
        .el-button {
            margin-right: 10px;
        }
        .el-radio{
            margin-right:0;
        }
        .inputs{
            margin-left:10px;
        }
    }
</style>
